export default {
  title: "",
  subtitle: "",
  path: "transaction_boleto_get",
  paragraph: "After receiving the response, retrieve the 'data.id' field and use it in the following endpoint to download the boleto PDF. The API will return the PDF file directly as a binary response.",
  request:  {
    method: "GET", 
    endpoint: "/transactions/:id/boleto_pdf"
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "The ID generated when a boleto transaction is created."
    }
  ],
  hyperlink: {
    linkPath: "/static/documentation/boleto_sample.pdf",
    linkText: "Download boleto pdf sample"
  }
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionBoletoGet.js